'use client';

import { useOverwolfApi } from '../../hooks/use-overwolf-api';
import { OverwolfLogin } from './overwolf-login';
import { WebLogin } from './web-login';

export type LoginCloseType = 'success' | 'skip';

// -----------------------------------------------------------------------------
// Picks the login flow for the current environment: inside the Overwolf client we
// trigger the client's native login overlay; on the public web we render the
// email/password + social form.
export const Login = (): JSX.Element => {
  const { isAvailable: isOverwolfClient } = useOverwolfApi();

  return isOverwolfClient ? <OverwolfLogin /> : <WebLogin />;
};
